@if (editInline()) {
    <se-masked-date-cell-editor-inline
        [maskedDateFormControl]="formControl"
        [inputType]="inputType()"
        [dateInputFormat]="dateInputFormat()"
        [timeInputFormat]="timeInputFormat()"
        [dateTimeInputFormat]="dateTimeInputFormat()"
        [dateSeparator]="dateSeparator()"
        [timeSeparator]="timeSeparator()"
        [cellReady]="cellReady()"
    >
    </se-masked-date-cell-editor-inline>
} @else {
    <se-masked-date-cell-editor-popup
        [maskedDateFormControl]="formControl"
        [inputType]="inputType()"
        [dateInputFormat]="dateInputFormat()"
        [timeInputFormat]="timeInputFormat()"
        [dateTimeInputFormat]="dateTimeInputFormat()"
        [dateSeparator]="dateSeparator()"
        [timeSeparator]="timeSeparator()"
        [cellReady]="cellReady()"
        [width]="cellWidth()"
    >
    </se-masked-date-cell-editor-popup>
}
